import { createContext } from "react";

export type ToastTone = "success" | "error";
export interface ToastOptions {duration?:number;actionLabel?:string;actionHref?:string;onAction?:()=>void}
export interface ToastItem extends ToastOptions { id: number; message: string; tone: ToastTone }
export interface ToastContextValue { showToast: (message: string, tone?: ToastTone, options?:ToastOptions) => void }

export const ToastContext = createContext<ToastContextValue | null>(null);
